import { ObtenerTablaPresuntivaDepositoImpresionMS } from './../../../open-api/model/obtenerTablaPresuntivaDepositoImpresionMS';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabla-presuntiva-dpf',
  templateUrl: './tabla-presuntiva-dpf.component.html',
  styleUrls: ['./tabla-presuntiva-dpf.component.scss']
})
export class TablaPresuntivaDpfComponent implements OnInit {

  @Input() tabla?: ObtenerTablaPresuntivaDepositoImpresionMS;

  constructor() { }

  ngOnInit(): void {
  }

}
